/**
 * Hulp bij foto's voor feedback: welke soorten de kiezer aanbiedt, en de
 * afbeeldingen uit een plakactie. Apart van `Bijlagen.tsx`, zodat dat bestand
 * alleen onderdelen exporteert (snel verversen tijdens ontwikkelen).
 */
import type { ClipboardEvent } from "react";

/** Wat de kiezer aanbiedt. De API controleert de inhoud zelf opnieuw. */
export const FOTO_SOORTEN = "image/png,image/jpeg,image/gif,image/webp";

/** De afbeeldingen uit een plakactie, met een naam als het klembord er geen geeft. */
export function fotosUitPlakken(event: ClipboardEvent): File[] {
  const bestanden: File[] = [];
  for (const item of Array.from(event.clipboardData?.items ?? [])) {
    if (item.kind !== "file" || !item.type.startsWith("image/")) continue;
    const bestand = item.getAsFile();
    if (!bestand) continue;
    const extensie = item.type.split("/")[1] ?? "png";
    bestanden.push(bestand.name && bestand.name !== "image.png"
      ? bestand
      : new File([bestand], `schermafbeelding-${bestanden.length + 1}.${extensie}`, { type: item.type }));
  }
  return bestanden;
}
